import { Typography } from '@mui/material';
import React, { FC } from 'react';

import AttachmentList from '../../../components/Attachments/AttachmentList';
import AttachmentUploadSection from '../../../components/MUI/AttachmentUploadSection';
import MuiIcon from '../../../components/MUI/MuiIcon';
import useAttachmentUpload from '../../../hooks/attachments/useAttachmentUpload';
import useIsMobile from '../../../hooks/useIsMobile';
import translate from '../../../i18n/translate';
import { ComposeNodeType } from '../props';

import * as Styled from './styled';

type Props = {
  nodeType: ComposeNodeType;
};

/**
 * Attachments container for the compose form
 *
 * @param props          Props passed to the container
 * @param props.nodeType Whether the compose form is being used for messages or templates
 * @returns              The container itself
 */
const ComposeMetaAttachmentsContainer: FC<Props> = ({ nodeType }) => {
  const { attachmentsFormatted, handleFileRemove, inputProps } =
    useAttachmentUpload(nodeType);

  const isMobile = useIsMobile();
  const shouldShowAttachmentsCount =
    isMobile && attachmentsFormatted.length > 0;

  return (
    <>
      {shouldShowAttachmentsCount && (
        <Styled.AttachmentsCount>
          <MuiIcon color="primary" fontSize="small" icon="attachFile" />
          <Typography>
            {translate('MESSAGE__HEADING__ATTACHMENTS')}
            {` (${attachmentsFormatted.length})`}
          </Typography>
        </Styled.AttachmentsCount>
      )}
      {!isMobile && (
        <AttachmentUploadSection
          attachmentsListLength={attachmentsFormatted.length}
          inputFileProps={inputProps}
        />
      )}
      {attachmentsFormatted.length > 0 && (
        <AttachmentList
          attachments={attachmentsFormatted}
          mode="compose"
          requestFileRemove={handleFileRemove}
        />
      )}
    </>
  );
};

export default ComposeMetaAttachmentsContainer;
